<microsec-form-builder
  #fb
  [isPage]="true"
  [shouldShowActionButtons]="false"
  [fields]="fields"
  [hasInfoFields]="false"
  [shouldSubmitOnEnter]="false" />
